import { lazy, Suspense } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import AdminGuard from './components/AdminGuard'
import AdminLayout from './components/AdminLayout'

const Dashboard = lazy(() => import('./pages/Dashboard'))
const Users = lazy(() => import('./pages/Users'))
const UserDetail = lazy(() => import('./pages/UserDetail'))
const Moderation = lazy(() => import('./pages/Moderation'))
const Content = lazy(() => import('./pages/Content'))
const Subscriptions = lazy(() => import('./pages/Subscriptions'))
const Notifications = lazy(() => import('./pages/Notifications'))
const Monitoring = lazy(() => import('./pages/Monitoring'))
const AuditLog = lazy(() => import('./pages/AuditLog'))
const AuthEvents = lazy(() => import('./pages/AuthEvents'))
const Reports = lazy(() => import('./pages/Reports'))
const Feedback = lazy(() => import('./pages/Feedback'))
const AppConfig = lazy(() => import('./pages/AppConfig'))
const ABTest = lazy(() => import('./pages/ABTest'))
const DesignSystem = lazy(() => import('./pages/DesignSystem'))

export default function AdminApp() {
  return (
    <AdminGuard>
      <Suspense fallback={
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100dvh' }}>
          <p style={{ fontSize: '14px', color: 'var(--color-text-tertiary)' }}>로딩 중...</p>
        </div>
      }>
        <Routes>
          <Route element={<AdminLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="users" element={<Users />} />
            <Route path="users/:id" element={<UserDetail />} />
            <Route path="moderation" element={<Moderation />} />
            <Route path="content" element={<Content />} />
            <Route path="subscriptions" element={<Subscriptions />} />
            <Route path="notifications" element={<Notifications />} />
            <Route path="monitoring" element={<Monitoring />} />
            <Route path="audit" element={<AuditLog />} />
            <Route path="auth-events" element={<AuthEvents />} />
            <Route path="reports" element={<Reports />} />
            <Route path="feedback" element={<Feedback />} />
            <Route path="app-config" element={<AppConfig />} />
            <Route path="ab-test" element={<ABTest />} />
            <Route path="design-system" element={<DesignSystem />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </AdminGuard>
  )
}
